module.exports = __webpack_public_path__ + "static/media/send-icon.b83145c7.svg";